import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { fromJS } from "immutable";
import { submitBookingForm as submitBookingFormLogic } from "./utils";
import { actions as appActions } from "../App";
import { withRouter } from "react-router";
import { selectors as reservationSelectors } from "../ReservationManager";
// appSelectors import does not work because of circular dependency
const appSelectors = require("../App/selectors");
import {
  bookingFormFieldsSelector,
  bookingFormInitialValuesSelector,
  bookingFormSelector,
} from "./selectors";

import { BookingForm } from "~/components";
import { bookingFormActions } from "../../redux/modules/bookingForm";
import get from "lodash/get";

const selectors = { ...appSelectors, ...reservationSelectors };

class BookingFormWrapper extends Component {
  constructor(props) {
    super(props);
    let initialValues = {};
    for (const k in this.props.bookingFormInitialValues) {
      initialValues[k] = { value: this.props.bookingFormInitialValues[k] };
    }
    this.state = {
      submitting: false,
      lastValues: initialValues,
      promoCodesValue: get(props.restoredSession, "promoCodes", undefined) ? "" : undefined,
    };
    this.handleChangeTab = this.handleChangeTab.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChangeTab({ tab, locale, propertyTicker, changeConfiguration }) {
    const requestParams = {
      locale: locale,
      propertyTicker: propertyTicker,
      selectedTab: tab,
    };
    changeConfiguration({
      propertyTicker: propertyTicker,
      configuration: fromJS(requestParams),
    });
  }

  componentDidMount() {
    this.props.bookingFormChanged(this.props.bookingFormInitialValues);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.lastValues !== prevState.lastValues) {
      this.setState({ lastValues: this.props.bookingForm });
    }
  }

  handleSubmit(customSubmit) {
    return e => {
      if (e) e.preventDefault();
      customSubmit();
      this.setState({ lastValues: null });
    };
  }

  fieldDefinitions = (formValues, initialValues) => ({
    startDate: {
      name: "startDate",
      onChange: value => {
        this.props.bookingFormChanged({ startDate: value });
      },
      initial: initialValues.startDate && initialValues.startDate.value,
      value: formValues.startDate.value,
    },
    endDate: {
      name: "endDate",
      onChange: value => {
        this.props.bookingFormChanged({ endDate: value });
      },
      initial: initialValues.endDate && initialValues.endDate.value,
      value: formValues.endDate.value,
    },
    hotelSelector: {
      name: "hotelSelector",
      onChange: value => {
        this.props.bookingFormChanged({ hotelSelector: value });
      },
      initial: (initialValues.hotelSelector && initialValues.hotelSelector.value) || "",
      value: formValues.hotelSelector.value || "",
    },
    filters: {
      name: "filters",
      onChange: value => {
        this.props.bookingFormChanged({ filters: value });
      },
      initial: (initialValues.filters && initialValues.filters.value) || "",
      value: formValues.filters.value || "",
    },
    promoCodes: {
      name: "promoCodes",
      onChange: e => {
        let promoCodes = e.target.value;
        if (this.state.promoCodesValue !== undefined) {
          promoCodes =
            initialValues.promoCodes && `${initialValues.promoCodes.value},${promoCodes}`;
          this.setState({ promoCodesValue: e.target.value });
        }
        this.props.bookingFormChanged({ promoCodes });
      },
      initial: (initialValues.promoCodes && initialValues.promoCodes.value) || "",
      value: formValues.promoCodes.value || "",
    },
    ADULT: {
      name: "ADULT",
      onChange: e => {
        this.props.bookingFormChanged({ ADULT: e.target.value });
      },
      initial: (initialValues.ADULT && initialValues.ADULT.value) || "",
      value: formValues.ADULT.value || "",
    },
    CHILD: {
      name: "CHILD",
      onChange: e => {
        this.props.bookingFormChanged({ CHILD: e.target.value });
      },
      initial: (initialValues.CHILD && initialValues.CHILD.value) || "",
      value: formValues.CHILD.value || "",
    },
    BABY: {
      name: "BABY",
      onChange: e => {
        this.props.bookingFormChanged({ BABY: e.target.value });
      },
      initial: (initialValues.BABY && initialValues.BABY.value) || "",
      value: formValues.BABY.value || "",
    },
    childrenCount: {
      name: "childrenCount",
      onChange: e => {
        this.props.bookingFormChanged({ childrenCount: e.target.value });
      },
      initial: (initialValues.childrenCount && initialValues.childrenCount.value) || "",
      value: formValues.childrenCount.value || "",
    },
  });

  isPristine(fields) {
    for (const k in fields) {
      if (fields[k].initial != fields[k].value) {
        return false;
      }
    }

    return true;
  }

  render() {
    const {
      customStyles,
      propertyTabs,
      propertyActiveTab,
      startDate,
      endDate,
      showElementsConfig,
      locale,
      propertyTicker,
      propertyTicker: globalPropertyTicker,
      bookingFormFields,
      promoCode,
      bookingFormInitialValues: initialValues,
      propertyFilters,
      deviceInfo,
      propertyTickers,
      activeFilters,
      fullWidth,
      logos,
      hotelSiteURL,
      bookingForm,
      menuMarkup,
      menuButtonMarkup,
      showMenu,
      showBookingForm,
      isWithotel,
      ariLoading,
      changeConfiguration,
      addAlert,
      requestARI,
      handleModalContent,
      handleCloseModal,
      handleWithotelMenu,
      currentStep,
      isBookingFormSummaryOpened,
      toggleBookingFormSummary,
      showBestPriceGuaranteed,
    } = this.props;
    const { promoCodesValue } = this.state;
    const push = this.props.history.push;
    const selectorsRange = bookingFormFields && bookingFormFields.selectorsRange;
    const ageRanges = bookingFormFields && bookingFormFields.ageRanges;
    const fields =
      (this.props.bookingFormFields &&
        this.props.bookingFormFields.fields &&
        Object.keys(this.props.bookingFormFields.fields).filter(
          fieldName => this.props.bookingFormFields.fields[fieldName]
        )) ||
      null;

    let definition;
    if (fields) {
      definition = this.fieldDefinitions(this.props.bookingForm || {}, this.state.lastValues || {});
      Object.keys(definition).forEach(k => {
        if (!fields.find(key => k === key)) delete definition[k];
      });
    } else {
      definition = {};
    }
    const pristine = this.isPristine(definition);
    const handleChangeTab = tab =>
      this.handleChangeTab({ tab, locale, propertyTicker, changeConfiguration });

    /* TODO: check propertyTicker vs callingTicker */
    const submitBookingForm = ({
      formValues,
      propertyTicker: innerPropertyTicker,
      guestAges,
      newBookingForm,
    }) => {
      if (promoCodesValue !== undefined) {
        this.setState({ promoCodesValue: "" });
      }
      submitBookingFormLogic({
        propertyTicker: innerPropertyTicker,
        formValues,
        guestAges,
        bookingFormFields,
        locale,
        globalPropertyTicker,
        changeConfiguration,
        addAlert,
        requestARI,
        bookingForm: newBookingForm || fields,
        push,
        currentStep,
      });
    };

    if (!showElementsConfig.showBookingForm && !fields) {
      return null;
    }

    if (definition && definition.promoCodes && promoCodesValue !== undefined) {
      definition.promoCodes.value = promoCodesValue;
    }
    return (
      <BookingForm
        styles={{
          backgroundColor: customStyles && "#" + customStyles.get("bookingFormBackgroundColor"),
        }}
        handleSubmit={this.handleSubmit}
        submitting={this.state.submitting}
        propertyTabs={propertyTabs} // not used
        selectedTab={propertyActiveTab && propertyActiveTab.get("optionTicker")}
        startDate={startDate} // minDate
        endDate={endDate} // maxDate
        fields={definition} // pre selected fields
        pristine={pristine} // button blinking
        promoCode={promoCode} // show or not prome code
        selectorsRange={selectorsRange} // por ver
        ageRanges={ageRanges} // por ver
        childrenAgeRange={selectorsRange && selectorsRange.childrenAges} // if there is children range
        initialValuesAlias={initialValues} // all initial values (occupants, filter, dates)
        propertyFilters={propertyFilters} // init filters
        deviceInfo={deviceInfo} // device info
        propertyTickers={propertyTickers} // filter data
        activeFilters={activeFilters}
        showLogo={fullWidth}
        showMobileLogo={showElementsConfig.showMobileLogo}
        showDesktopLogo={showElementsConfig.showDesktopLogo}
        logos={logos}
        hotelSiteURL={hotelSiteURL}
        handleChangeTab={handleChangeTab}
        handleModalContent={handleModalContent}
        handleCloseModal={handleCloseModal}
        onSubmit={submitBookingForm}
        customSubmit={submitBookingForm}
        fullWidth={fullWidth}
        menuMarkup={menuMarkup}
        menuButtonMarkup={menuButtonMarkup}
        showMenu={showMenu}
        showBookingForm={showBookingForm}
        isWithotel={isWithotel}
        handleWithotelMenu={handleWithotelMenu}
        ariLoading={ariLoading}
        bookingForm={bookingForm}
        isBookingFormSummaryOpened={isBookingFormSummaryOpened}
        toggleBookingFormSummary={toggleBookingFormSummary}
        showBestPriceGuaranteed={showBestPriceGuaranteed}
      />
    );
  }
}

export default connect(
  createStructuredSelector({
    customStyles: selectors.customStylesSelector,
    propertyTabs: selectors.propertyTabsSelector,
    propertyActiveTab: selectors.propertyActiveTabSelector,
    propertyTicker: selectors.propertyTickerSelector,
    locale: selectors.localeSelector,
    startDate: selectors.startDateSelector,
    endDate: selectors.endDateSelector,
    promoCode: selectors.promoCodeSelector,
    bookingFormFields: bookingFormFieldsSelector,
    bookingFormInitialValues: bookingFormInitialValuesSelector,
    propertyFilters: selectors.propertyFiltersSelector,
    deviceInfo: selectors.deviceInfoSelector,
    propertyTickers: selectors.propertyTickersSelector,
    activeFilters: selectors.activeFiltersSelector,
    fullWidth: selectors.fullWidthSelector,
    logos: selectors.logosSelector,
    hotelSiteURL: selectors.hotelSiteURLSelector,
    showElementsConfig: selectors.showElementsConfigSelector,
    bookingForm: bookingFormSelector,
    showBestPriceGuaranteed: selectors.showBestPriceGuaranteedSelector,
    restoredSession: selectors.restoredSessionSelector,
  }),
  dispatch => bindActionCreators({ ...appActions, ...bookingFormActions }, dispatch)
)(withRouter(BookingFormWrapper));

//TODO: Correct proptypes
// BookingFormWrapper.propTypes = {
//   customStyles: PropTypes.object,
//   propertyTabs: PropTypes.object,
//   propertyActiveTab: PropTypes.string,
//   promoCode: PropTypes.string,
//   startDate: PropTypes.object,
//   endDate: PropTypes.object,
//   locale: PropTypes.string,
//   propertyTicker: PropTypes.string,
//   showElementsConfig: PropTypes.object,
//   fields: PropTypes.array,
//   changeConfiguration: PropTypes.func,
//   addAlert: PropTypes.func,
//   requestARI: PropTypes.func,
//   handleModalContent: PropTypes.func,
//   handleCloseModal: PropTypes.func,
//   bookingFormFields: PropTypes.object,
//   bookingFormInitialValues: PropTypes.object,
//   propertyFilters: PropTypes.object,
//   deviceInfo: PropTypes.object,
//   hotelSiteURL: PropTypes.string,
//   propertyTickers: PropTypes.array,
//   activeFilters: PropTypes.array,
//   logos: PropTypes.object,
//   fullWidth: PropTypes.bool,
//   bookingForm: PropTypes.object,
//   currentStep: PropTypes.string,
// };
